/**
 * This is a simple utility to log a message in local dev or staging, but
 * stay silent in production.
 */
export function nonProdLogger(message: string, host?: string) {
  let inProd = false
  // Handle case where code is run server-side, where window does not exist.
  try {
    inProd = (host ?? window.location.host).includes("theconversation.com")
  } catch {
    inProd = false
  }

  if (!inProd) {
    console.log(message)
  }
}
